import { render, staticRenderFns } from "./breadcrumbFour.vue?vue&type=template&id=63eb8736&"
import script from "./breadcrumbFour.vue?vue&type=script&lang=js&"
export * from "./breadcrumbFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports